<template>
  <RmField :field="lot.id">
    <div
      class="lot-side-surface relative px-2.5 md:px-4 py-4 my-2.5 rounded-2xl"
    >
      <div class="text-xs text-gray-600">Срок аренды:</div>
      <div class="flex justify-between">
        <div class="text-sm font-bold text-black">
          c {{ $dayjs(range.dateFrom).format('D MMMM') }} по
          {{ $dayjs(range.dateTo).format('D MMMM') }}
        </div>
        <button
          class="text-xs font-medium text-blue-500 cursor-pointer"
          @click="handleSelectDate"
        >
          Изменить даты
        </button>
      </div>

      <RmBtn
        id="getorder"
        color="blue"
        class="w-full h-12 mt-4 rounded-2xl"
        @click="handleAddressSelect"
      >
        Заказать
      </RmBtn>
    </div>
  </RmField>
</template>

<script>
import RmBtn from '~/components/shared/rm_btn.vue'
import RmField from '~/components/shared/rm_field.vue'
import { useElka } from '~/composables/useElka'
import { useLot } from '~/composables/useLot'
export default {
  components: {
    RmField,
    RmBtn,
  },

  props: {
    lotId: {
      type: [String, Number],
      default: 0,
    },
  },
  setup (props) {
    const { lot, isLoading } = useLot(props.lotId)
    const { range, handleSelectDate, handleAddressSelect, handleGetOrder } = useElka(props.lotId)
    const cart = useCart().item
    const hasSelectedDate = computed(() => {
      return Boolean(cart.value?.dateFrom && cart.value?.dateTo)
    })
    return {
      lot,
      range,
      showBottomPanelInLot: useGlobal().showBottomPanelInLot,
      deliveryFlag: computed(() => lot.value.deliveryFlag),
      isLoading,
      priceDetails: computed(() => lot.value.priceDetails),
      hasSelectedDate,
      handleSelectDate: () => handleSelectDate(lot.value, lot.value.minRentDays),
      handleAddressSelect,
      handleGetOrder,
    }
  },

  computed: {
    deliveryOptions () {
      return [
        {
          delivery: true,
          text: `Курьером — ${this.deliveryPrice}\u00A0₽`,
        },
      ]
    },
    selectedDelivery () {
      return this.deliveryOptions.find(item => item.delivery === this.deliveryFlag)
    },
    deposit () {
      return this.priceDetails.deposit
    },
    deliveryPrice () {
      return this.lot.deliveryPrice
    },
    deliveryTitle () {
      return this.$t('lots.id.deliveryReturns') + ': ' + this.deliveryPrice + '\u00A0₽'
    },
  },
  methods: {
    viewHandler (e) {
      if (
        e.percentCenter === 0 &&
          e.percentInView === 0 &&
          e.percentTop === 0 &&
          e.scrollPercent === 0
      ) {
        this.showBottomPanelInLot = false
        return
      }

      if (e.type === 'exit' && e.percentInView < 0.1) {
        this.showBottomPanelInLot = true
      } else {
        this.showBottomPanelInLot = false
      }
    },

  },
}
</script>
